import './style.css'
import LpApp from './LpApp/LpApp.js'

const lpApp = new LpApp(document.querySelector('canvas.webgl'));

